import { api } from "../api";
import { useApiData } from "../useApi";
import { PageState } from "../components";

export function Configuration({ onSignedOut }: { onSignedOut: () => void }) {
  const { data, error, loading } = useApiData(() => api.config(), onSignedOut);

  return (
    <>
      <h1>Configuration</h1>
      <p className="subtitle">What this server is currently running with.</p>

      <PageState loading={loading} error={error}>
        {data && (
          <>
            {/* The server decides this, not the UI — hiding an edit button
                the API would have accepted is not a control. */}
            {!data.editable_here && (
              <div className="notice">{data.editable_here_reason}</div>
            )}

            <div className="card">
              <h2>Execution</h2>
              <table>
                <tbody>
                  <Row label="Allowed EA modes" value={data.allowed_ea_modes.join(", ")} />
                  <Row label="Command poll limit" value={String(data.command_poll_limit)} />
                  <Row
                    label="Ack→result timeout"
                    value={`${data.ack_result_timeout_seconds}s`}
                    note="After this, an acknowledged command becomes UNKNOWN and needs reconciliation."
                  />
                </tbody>
              </table>
            </div>

            <div className="card">
              <h2>Policy sources</h2>
              <table>
                <tbody>
                  <Row label="Risk policy" value={data.risk_policy_path ?? "not configured"} />
                  <Row
                    label="Instrument registry"
                    value={data.instrument_registry_path ?? "not configured"}
                    note="Without both of these, GET /policy fails closed and the EA refuses to trade."
                  />
                </tbody>
              </table>
            </div>
          </>
        )}
      </PageState>
    </>
  );
}

function Row({ label, value, note }: { label: string; value: string; note?: string }) {
  return (
    <tr>
      <td style={{ width: 200 }}>{label}</td>
      <td className="mono">
        {value}
        {note && (
          <div className="dim" style={{ fontFamily: "system-ui", marginTop: 3 }}>
            {note}
          </div>
        )}
      </td>
    </tr>
  );
}
